<template>
  <div class="error-container">
    <div class="error-message">
      <h2 class="error-title">404</h2>
      <p class="error-text">Page Not Found</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorNotFound"
};
</script>

<style scoped>
.error-container {
  width: 100%;
}
.error-message {
  width: fit-content;
  margin: auto;
}
.error-title {
  text-align: center;
  font-size: 2rem;
}
.error-text {
  text-align: center;
  font-size: 1.25rem;
}
</style>

<style>
body {
  background-color: #a1a1a1;
  color: white;
}
</style>
